import "./App.css";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Routes, Route, HashRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Home from "./Component/Home/Home.jsx";
import Login from "./Authentication/Login/Login.jsx";
import Signup from "./Authentication/Signup/Signup.jsx";
import ForgetPassword from "./Authentication/ForgetPsw/ForgetPassword.jsx";
import LoginWithOtp from "./Authentication/LoginWithOtp/LoginWithOtp.jsx";
import MobilePrepaid from "./PaymentServicePages/MobileRechargePrepaid/MobilePrepaid.jsx";
import Electricity from "./PaymentServicePages/Electricity/Electricity.jsx";
import DthService from "./PaymentServicePages/DTHService/DthService.jsx";
import ApiCalling from "./ApiServices/ApiCalling.js";
import TransactionReport from "./Account/Transaction/TransactionReport.jsx";
import Ledger from "./Account/Ledger/Ledger.jsx";
import Profile from "./Account/Profile/Profile.jsx";
import WalletToTransfer from "./Account/WalletToWallet/WalletToTransfer.jsx";
import UpdateMembership from "./Account/MembershipUpdation/UpdateMembership.jsx";
import ProtectedRoute from "./ProtectedRoute/ProtectedRoute.jsx";
import PgRedirectB2C from "./PaymentServicePages/PgRedirectB2C.jsx";
import ChatWidget from "./PaymentServicePages/ChatWidget/ChatWidget.jsx";
import { ServiceContext } from "./ServiceContext.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermCondition from "./pages/TermCondition.jsx";
import RefundPolicy from "./pages/RefundPolicy.jsx";

function App() {
  const [services, setServices] = useState([]);

  const location = useLocation();

  useEffect(() => {
    const fetchOpTypes = async () => {
      try {
        const res = await ApiCalling.request("POST", "/GetOpTypes");
        if (res?.statuscode === 1) {
          setServices(res?.data?.assignedOpTypes || []);
        }
      } catch (err) {
        console.error("Error fetching operator types", err);
      }
    };

    fetchOpTypes();
  }, []);

  const serviceTypeSlugMap = {
    1: "recharge",
    11: "billpayment",
  };
  if (services === null) return null;
  return (
    <>
      <ServiceContext.Provider value={services}>
        <Toaster position="top-right" />
        <ChatWidget />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/loginOtp" element={<LoginWithOtp />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgetpassword" element={<ForgetPassword />} />
          <Route path="/PgRedirectB2C" element={<PgRedirectB2C />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermCondition />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />

          <Route
            path="/transactionreport"
            element={
              <ProtectedRoute>
                <TransactionReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ledgerreport"
            element={
              <ProtectedRoute>
                <Ledger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/walletTotransfer"
            element={
              <ProtectedRoute>
                <WalletToTransfer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/updatemembership"
            element={
              <ProtectedRoute>
                <UpdateMembership />
              </ProtectedRoute>
            }
          />

          {services.map((service) => {
            const slug =
              serviceTypeSlugMap[service.serviceTypeID] || "otherservice";
            const path = `/${slug}/${service.name
              .replace(/\s+/g, "")
              .toLowerCase()}`;

            let PageComponent = null;

            if (service.serviceTypeID === "11") {
              PageComponent = Electricity;
            }
            if (service.serviceTypeID === "1") {
              if (service.serviceID === 1) {
                PageComponent = MobilePrepaid;
              } else if (service.serviceID === 3) {
                PageComponent = DthService;
              }
            }
            if (!PageComponent) return null;

            return (
              <Route
                key={service.serviceID}
                path={path}
                element={<PageComponent serviceID={service.serviceID} />}
              />
            );
          })}
        </Routes>
      </ServiceContext.Provider>
    </>
  );
}

export default App;
